import { useEffect, useRef } from "react";

const presentation = {
  "not-found": {
    description:
      "A página que você procura não existe ou mudou de endereço.",
    title: "Página não encontrada",
  },
  unexpected: {
    description:
      "Algo saiu do esperado. Tente novamente ou volte para a loja.",
    title: "Não foi possível abrir esta página",
  },
} as const;

export function RouteError({
  kind,
  onRetry,
}: {
  readonly kind: keyof typeof presentation;
  readonly onRetry?: () => void;
}) {
  const heading = useRef<HTMLHeadingElement>(null);
  const content = presentation[kind];

  useEffect(() => {
    heading.current?.focus();
  }, []);

  return (
    <main className="grid min-h-dvh place-items-center bg-[var(--app-background)] px-5 py-10 text-[var(--app-foreground)]">
      <section
        aria-labelledby="route-error-title"
        className="w-full max-w-xl rounded-[var(--radius-feature)] border border-[var(--app-border)] bg-[var(--color-surface)] p-6 shadow-[var(--shadow-floating)] sm:p-10"
      >
        <p className="mb-3 font-semibold text-[var(--color-action)]">
          Alfabetizando
        </p>
        <h1
          className="text-3xl font-bold tracking-tight focus:outline-none"
          id="route-error-title"
          ref={heading}
          tabIndex={-1}
        >
          {content.title}
        </h1>
        <p className="mt-3 text-[var(--color-muted)]">
          {content.description}
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <a
            className="rounded-[var(--radius-control)] bg-[var(--color-action)] px-5 py-3 font-semibold text-[var(--color-surface)] no-underline"
            href="/"
          >
            Voltar para a loja
          </a>
          {onRetry ? (
            <button
              className="rounded-[var(--radius-control)] border border-[var(--app-border)] bg-[var(--color-surface)] px-5 py-3 font-semibold text-[var(--app-foreground)]"
              onClick={onRetry}
              type="button"
            >
              Tentar novamente
            </button>
          ) : null}
        </div>
      </section>
    </main>
  );
}
